<!-- @format -->

<!-- eslint-disable -->
<template>
  <v-card class="my-2">
    <v-card-text>
      <v-data-table
        dense
        :items="items"
        :headers="headers"
        class="elevation-1"
        mobile-breakpoint="0"
        :loading="loader"
        hide-default-footer
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id | folio }}
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          {{ item.fecha | date }}
        </template>
        <template v-slot:[`item.importe`]="{ item }">
          {{ item.importe | moneda }}
        </template>
        <template v-slot:[`item.cajas`]="{ item }">
          {{ item.cajas | numero }}
        </template>
      </v-data-table>
      <Pagination :loader="loader" :items="items" :paginado="paginado" />
    </v-card-text>
    <v-card-actions>
      <v-btn small color="primary" @click="getAll" :disabled="loader">actualizar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "Ventas",
    data: () => ({
      items: [],
      headers: [
        { text: "Folio", value: "folio" },
        { text: "Fecha", value: "fecha" },
        { text: "Cliente", value: "cliente" },
        { text: "PU", value: "pu" },
        { text: "Expedientes", value: "expedientes" },
        { text: "Cajas", value: "cajas", align: "end" },
        { text: "Pallets", value: "pallets", align: "end" },
        { text: "Importe Producto", value: "importe", align: "end" },
        { text: "Facturado", value: "facturas", align: "center" },
        { text: "Nota", value: "nota" },
      ],
      loader: false,
      paginado: { currentPage: 1 },
      search: undefined,
    }),
    mounted() {
      this.getAll();
    },
    computed: {
      actual() {
        return this.paginado.currentPage;
      },
    },
    methods: {
      getAll() {
        this.loader = true;
        this.items = [];
        window.axios
          .get("FR/dashboard/getVentasMes", {
            params: { page: this.paginado.currentPage },
          })
          .then((resp) => {
            this.items = resp.data.collection;
            this.paginado = resp.data.paginado;
          })
          .catch((e) => this.$store.dispatch("errores", e))
          .finally(() => (this.loader = false));
      },
    },
    watch: {
      actual() {
        this.getAll();
      },
    },
  };
</script>
